<donut-button class="inv m-tx2" v-if="userDatesDetails.usersMissingDates.length &gt; 0" @click="openAskForDatesModal">Ask for dates</donut-button>